<!--<div [class]="property.IsViewed==0?'box unvisited':'box'" id="{{property.Id}}_tileDiv">-->
<div [class]="propDivClass" id="{{property.Id}}_tileDiv" #scrolldiv>

  <div class="img-outer outer-box">
    <a *ngIf="!isUserLoggedIn && property.Slug" href="/viewproperty/{{property.Slug}}" style="position:relative;width:100%;display:block;height: 100%;">
      <ng-container *ngTemplateOutlet="cardFlags">
      </ng-container>
    </a>
    <a *ngIf="isUserLoggedIn || !property.Slug" href="javascript:void(0);" (click)="onViewProperty(property.Slug ? property.Slug : property.Guid);">
      <ng-container *ngTemplateOutlet="cardFlags">
      </ng-container>
    </a>
    <div class="alinktransitionhide" *ngIf="!showDisLike && userLoggedIn">
      <a tooltip="{{toolTipFav}}" placement="left" *ngIf="showAddToFav" href="javascript:void(0);" [class]="classToBind" (click)="addToFav(property.Id);"><!--<i class="fa fa-heart icon"></i>--><i class="fa fa-heart-o icon"></i></a>
      <div class="clearfix"></div>
    </div>
    <div *ngIf="showDisLike && userLoggedIn">
      <a *ngIf="classToBindDislike != 'dislikedClicked'" tooltip="{{toolTipFav}}" placement="left" href="javascript:void(0);" [class]="classToBind" (click)="addToFav(property.Id);"><i class="fa fa-heart-o icon"></i></a>
      <a *ngIf="classToBind != 'favClicked' && Is1031Property" tooltip="{{toolTipDisLike}}" placement="left" href="javascript:void(0);" [class]="classToBindDislike" (click)="addToDisliked(property.Id);"><i class="fa fa-thumbs-o-down icon"></i></a>
    </div>
  </div>

  <a *ngIf="!isUserLoggedIn && property.Slug" (click)="gotoPropertyDetails(property.Slug)">
    <div class="contentsection">
      <div class="be-prop-details">
        <div class="be-prop-top">
          <a (click)="gotoPropertyDetails(property.Slug)">
            <h2>
              <span *ngIf="property.City!='Confidential'&&!property.IsPortfolio" class="margin-bottom-10 property-address">
                <i class="fa fa-map-marker" aria-hidden="true"></i>
                {{property.City ? property.City + "," : ""}} {{property.State}}
              </span>
              <span *ngIf="property.City=='Confidential'&&!property.IsPortfolio" class="margin-bottom-10 property-address">
                <i class="fa fa-map-marker" aria-hidden="true"></i>
                {{property.City ? property.City : ""}}
              </span>
              <span class="tool-top-box toolt-tip-word-break margin-bottom-10" *ngIf="property?.IsPortfolio">
                <span placement="top" tooltip="{{property.PortfolioLocation!=null&&property.PortfolioLocation!=undefined?property.PortfolioLocation:''}}" style="display:inline;" class=" property-address">
                  <i class="fa fa-map-marker" aria-hidden="true" *ngIf="property.PortfolioCurrentLocation!=null&&property.PortfolioCurrentLocation!=''"></i>
                  {{GetPropertyLocationWithCount(property.PortfolioCurrentLocation)}}
                </span>
              </span>
              <strong>{{property.PropertyName}}</strong>
            </h2>
          </a>

          <a (click)="gotoPropertyDetails(property.Slug)" style="margin-right:5px;">{{_commonService.GetPropertyTypeWithCount(property.AssetType)}}</a>
        </div>
        <div class="row margin-top-10" style="margin-left:0px !important;">
          <div class="col-md-4">
            <label class="card-text">Cap Rate</label>
            <div class="data card-value">
              <span *ngIf="property.capRateText == 'ZCF'">{{property.capRateText}}</span>
              <span *ngIf="property.capRateText != 'ZCF'"> {{(property.CapRate && property.IsShowPrice) ? (property.CapRate | number : '1.2-2') + '%' : '-'}}</span>
            </div>
          </div>
          <div class="col-md-4">
            <label class="card-text">Remaining Term</label>
            <div class="data card-value">
              {{ property.IsPortfolio ? (property.PortfolioRemainingLeaseTerm ? property.PortfolioRemainingLeaseTerm : '-') : property.Remaining_Term}}
            </div>

          </div>
          <div class="col-md-4">
            <label class="card-text">Credit Rating</label>
            <div *ngIf="property.IsShowPrice;else hyphen" class="data card-value">{{property.Rating ?  property.Rating : '-'}}</div><ng-template #hyphen><div>-</div></ng-template>
          </div>
        </div>
        <ul class="be-pro-add-dtls not-logged-in">
          <li>
            <label>Asking Price</label>
            <div class="data blue-color-text" *ngIf="property.Unpriced">
              Unpriced
            </div>
            <div class="data blue-color-text" *ngIf="!property.Unpriced">
              {{(property.Price && property.IsShowPrice) ? '$ '+(property.Price | number:0) : '-'}}
            </div>
          </li>
        </ul>
      </div>

    </div>
    <!-- <label class="offer-btn" *ngIf="(property.PropertyStatus === 'Available' || property.PropertyStatus === 'Off-Market') && (property.OfferPlacedStatusId==457 || property.OfferPlacedStatusId==0) && showPlaceOffer">Place Offer</label>-->
    <label class="offer-details-btn" *ngIf="property.OfferPlacedStatusId!=457 && property.OfferPlacedStatusId!=0">Offer Details</label>
  </a>
  <a *ngIf="isUserLoggedIn || !property.Slug" href="javascript:void(0);" (click)="onViewProperty(property.Slug ? property.Slug : property.Guid);">
    <div class="contentsection">
      <div class="be-prop-details">
        <div class="be-prop-top">
          <a href="javascript:void(0);" (click)="onViewProperty(property.Slug ? property.Slug : property.Guid);">
            <h2>
              <span *ngIf="property.City!='Confidential'&&!property.IsPortfolio" class="margin-bottom-10 property-address">
                <i class="fa fa-map-marker" aria-hidden="true"></i>
                {{property.City ? property.City + "," : ""}} {{property.State}}
              </span>
              <span *ngIf="property.City=='Confidential'&&!property.IsPortfolio" class="margin-bottom-10 property-address">
                <i class="fa fa-map-marker" aria-hidden="true"></i>
                {{property.City ? property.City : ""}}
              </span>
              <span class="tool-top-box toolt-tip-word-break margin-bottom-10" *ngIf="property?.IsPortfolio">
                <span placement="top" tooltip="{{property.PortfolioLocation!=null&&property.PortfolioLocation!=undefined?property.PortfolioLocation:''}}" style="display:inline;" class=" property-address">
                  <i class="fa fa-map-marker" aria-hidden="true" *ngIf="property.PortfolioCurrentLocation!=null&&property.PortfolioCurrentLocation!=''"></i>
                  {{GetPropertyLocationWithCount(property.PortfolioCurrentLocation)}}
                </span>
              </span>
              <strong>{{property.PropertyName}}</strong>
            </h2>
          </a>

          <a href="javascript:void(0);" (click)="onViewProperty(property.Slug ? property.Slug : property.Guid);" style="margin-right:5px;">{{_commonService.GetPropertyTypeWithCount(property.AssetType)}}</a>
        </div>
        <div class="row margin-top-10" style="margin-left:0px !important;">
          <div class="col-md-3">
            <label class="card-text">Cap Rate</label>
            <div class="data card-value">
              <span *ngIf="property.capRateText == 'ZCF'">{{property.capRateText}}</span>
              <span *ngIf="property.capRateText != 'ZCF'"> {{(property.CapRate && property.IsShowPrice) ? (property.CapRate | number : '1.2-2') + '%' : '-'}}</span>
            </div>
          </div>
          <div class="col-md-5">
            <label class="card-text">Remaining Term</label>
            <div class="data card-value">
              {{ property.IsPortfolio ? (property.PortfolioRemainingLeaseTerm ? property.PortfolioRemainingLeaseTerm : '-') : property.Remaining_Term}}
            </div>

          </div>
          <div class="col-md-4">
            <label class="card-text">Credit Rating</label>
            <div *ngIf="property.IsShowPrice;else hyphen" class="data card-value">{{property.Rating ?  property.Rating : '-'}}</div><ng-template #hyphen><div>-</div></ng-template>
          </div>
        </div>
        <ul class="be-pro-add-dtls " [ngClass]="user && ((this.authService.IsUserRole(this.authService.UserRole.Broker)|| this.authService.IsUserRole(this.authService.UserRole.SuperAdmin) || this.authService.IsUserRole(this.authService.UserRole.Admin)))?'':'not-logged-in'">
          <li>
            <label>Asking Price</label>
            <div *ngIf="!property.Unpriced" class="data blue-color-text">
              {{(property.Price && property.IsShowPrice) ? '$ '+(property.Price | number:0) : '-'}}
            </div>
            <div *ngIf="property.Unpriced" class="data blue-color-text">
              Unpriced
            </div>
          </li>

          <li container="body" *ngIf="user && ((this.authService.IsUserRole(this.authService.UserRole.Broker) || this.authService.IsUserRole(this.authService.UserRole.Admin) || this.authService.IsUserRole(this.authService.UserRole.SuperAdmin)))">
            <div class="floatinghead floatinghead-xs clearfix" onclick="event.preventDefault(); event.stopPropagation();">
              <!-- class="btn-group" removed for solving issues in dropdown -->
              <div dropdown class="dropdown dropdown-property-card" id="{{property.Id}}">
                <a id="button-basic" dropdownToggle class=" btn adduserbtn dropdown-toggle "
                   aria-controls="dropdown-basic" data-bs-toggle="dropdown" data-bs-auto-close="inside" (click)="close(property.Id)">
                  <span class="icofont icofont-share icon"></span> Share
                </a>
                <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu dropdown-menu-right inner-list"
                    role="menu" aria-labelledby="button-basic">
                  <li role="menuitem"><a class="dropdown-item" href="javascript:void(0);" (click)="openModalForShareListing(ShareListing,'panlestyle',property);">Share Listings</a></li>
                  <li role="menuitem"><a class="dropdown-item" href="javascript:void(0);" (click)="openModalForShareOM(ShareOM,'portfolio-bov-modal shareom-document-modal',property);">Share OM</a></li>
                </ul>
              </div>
            </div>
          </li>
        </ul>
      </div>

    </div>
    <!--<label class="offer-btn" *ngIf="(property.PropertyStatus === 'Available' || property.PropertyStatus === 'Off-Market') && (property.OfferPlacedStatusId==457 || property.OfferPlacedStatusId==0) && showPlaceOffer">Place Offer</label>-->
    <!--<label class="offer-details-btn" *ngIf="property.OfferPlacedStatusId!=457 && property.OfferPlacedStatusId!=0">Offer Details</label>-->
  </a>

  <!--<a class="offer-btn offer-details-btn" routerLink="/offer-detail/{{property.OfferDetailGuid}}" *ngIf="property.OfferPlacedStatusId!=457 && property.OfferPlacedStatusId!=0">Offer Detail</a>-->

</div>

<ng-template #template class="pull-left">
  <be-place-offer [modalRef]="modalRef" [placeOfferInputModel]="placeOfferInputModel" [showFileUpload]="showFileUpload" (offerPlaced)="getOfferPlaced($event)"></be-place-offer>
</ng-template>

<ng-template #login>
  <app-login-form [modalRef]="modalRef"></app-login-form>
</ng-template>
<button id="openModalButton" [hidden]="true" (click)="openLoginModal(login,'commonmodal',property.Guid)"></button>

<ng-template #template1031 class="pull-left">
  <div class="modal-header">
    <h4 class="modal-title pull-left">{{AddOrEdit}}</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="form-group">
      <label class="form-label">1031 Exchange</label>
      <label class="select">
        <select class="form-control" #state="ngModel" [disabled]="exchangeCodes?.length === 1" [(ngModel)]="addTo1031Exchange.Exchange1031Id">
          <option value="0">--Select--</option>
          <option *ngFor="let item of exchangeCodes" [(ngValue)]="item.Id">{{item.ExchangeCode}}</option>
        </select>
        <i></i>
      </label>
    </div>
    <!--<div class="form-group">
        <label class="form-label">Group</label>
        <label class="select">
            <select class="form-control" #state="ngModel" [(ngModel)]="addTo1031Exchange.Exchange1031GroupId">
                <option value="0">--Select--</option>
                <option *ngFor="let item of groupList" [(ngValue)]="item.id">{{item.description}}</option>
            </select>
            <i></i>
        </label>
    </div>-->
    <div class="text-right">
      <button class="btn btn-default btn-lg" id="closeModal" (click)="modalRef.hide();">
        Cance
        l
      </button>
      ce

      la
      <button class="btn btn-success btn-lg" (click)="savePropertyto1031Exchange();">Save</button>
    </div>
  </div>

</ng-template>

<ng-template #addToExchange>
  <app-add-favorite-exchange [modalRef]="modalRefAddToExchange" [exchangeCodes]="exchangeCodes" (addToExchange)="addToExchangeSave($event)"></app-add-favorite-exchange>
</ng-template>

<ng-template #cardFlags>
  <ng-container [ngSwitch]="property?.Images?.length">
    <!-- 1 Image -->
    <div *ngSwitchCase="1" class="grid grid-1">
      <div class="img" [ngStyle]="{ 'background-image': 'url(' + property?.Images[0] + ')' }"></div>
    </div>

    <!-- 2 Images -->
    <div *ngSwitchCase="2" class="grid grid-2">
      <div class="img" *ngFor="let img of property?.Images?.slice(0, 2)" [ngStyle]="{ 'background-image': 'url(' + img + ')' }"></div>
    </div>

    <!-- 3 Images -->
    <div *ngSwitchCase="3" class="grid grid-3">
      <div class="img" [ngStyle]="{ 'background-image': 'url(' + property?.Images[0] + ')' }"></div>
      <div class="img" [ngStyle]="{ 'background-image': 'url(' + property?.Images[1] + ')' }"></div>
      <div class="img full-span" [ngStyle]="{ 'background-image': 'url(' + property?.Images[2] + ')' }"></div>
    </div>

    <!-- 4 Images -->
    <div *ngSwitchCase="4" class="grid grid-4">
      <div class="img" *ngFor="let img of property?.Images" [ngStyle]="{ 'background-image': 'url(' + img + ')' }"></div>
    </div>

  </ng-container>
  <div style="position:absolute;z-index:1;display: flex; gap: 10px; flex-wrap: wrap;padding-left: 15px;padding-top: 20px;max-width: calc(100% - 35px);top:0;">
    <span class="card-tag betagtext-propertycard margin-left-5" *ngIf="property.PropertyForId == 601 && isPropertyForSale == false">
      B+E
    </span>
    <span class="card-tag" style="" [ngClass]="{'redtext':(property.PropertyStatus === 'Closed' || property.PropertyStatus === 'Sold'),
                    'greentext':property.PropertyStatus === 'Available',
                    'gerytext':property.PropertyStatus === 'Under Contract','ashtext':property.PropertyStatus === 'Off-Market'}">
      {{property.PropertyStatus}}
    </span>
    <span class="card-tag be-tag-portfolioCount ashtext" *ngIf="property.IsPortfolio">
      <img src="/assets/img/Stack1.svg">
      <span class="margin-left-5" style="color: #9C9C9C !important;">{{property.PortfolioPropertyCount ? property.PortfolioPropertyCount :0}}</span>
    </span>
  </div>
</ng-template>
<ng-template #ShareOM>
  <app-share-omdocuments [propertyIds]="sharedOmProperties" [modalRefShareListing]="modalRefOM" (removeProperties)="removeProperty($event)"></app-share-omdocuments>
</ng-template>

<ng-template #ShareListing>
  <app-share-group-add [selectedProperties]="selectedProperties" [modalRefShareListing]="modalRefShareListing" (removeProperties)="removeProperty($event)"></app-share-group-add>

</ng-template>
